export function nameFromOperation(operation) {
  return operation.query?.definitions[0]?.selectionSet?.selections[0]?.name?.value;
}
